var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreemapPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 233,
    viewBox: "0 0 225 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 57.8945C16 48.6399 20.2921 39.7644 27.9322 33.2204C35.5722 26.6764 45.9343 23 56.7389 23H91.2103V216.262H56.7389C45.9343 216.262 35.5722 212.586 27.9322 206.042C20.2921 199.498 16 190.622 16 181.367V57.8945Z",
    fill: "#373D43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9141 215.309H174.482C183.704 215.309 192.548 211.041 199.069 203.445C205.59 195.849 209.254 185.547 209.254 174.804V146.763H96.9141V215.309Z",
    fill: "#868E96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.254 142.004V58.1602C209.254 48.8351 205.59 39.892 199.069 33.2982C192.548 26.7044 183.704 23 174.482 23H96.9141V142.004H209.254Z",
    fill: "#ADB5BD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreemapPreview);
export default __webpack_public_path__ + "static/media/treemapPreview.3d83c162d835429a6cebb8495bcce042.svg";
export { ForwardRef as ReactComponent };